import React from "react";

function CartItemsinCheckout({ item }) {
  const image = item.thumbnail;
  const title = item.title;
  const variantName = item.variantName;
  const quantity = item.quantity;
  const mrp = Number(item.mrp);
  const subtotal = Number(item.subtotal || 0);
  const customization = item.customization;

  const price = Number(item?.price || 0);

  return (
    <li className="checkout-item">
      <figure className="ci-img">
        <img src={image} alt={title || "product"} />
      </figure>

      <div className="ci-body">
        <p className="ci-name">{title}</p>

        {variantName && <span className="ci-meta">{variantName}</span>}

        <span className="ci-meta">
          Qty: <b>{quantity}</b>
        </span>

        {customization?.add_personalised_text && (
          <span className="ci-meta">
            Print: <b>{customization.add_personalised_text}</b>
          </span>
        )}

        <div className="ci-prices">
          <span className="ci-price">₹{price.toFixed(2)}</span>

          {!isNaN(mrp) && mrp > price && (
            <span className="ci-mrp">₹{mrp.toFixed(2)}</span>
          )}

          {quantity > 1 && (
            <span className="ci-total">Total ₹{subtotal.toFixed(2)}</span>
          )}
        </div>
      </div>
    </li>
  );
}

export default CartItemsinCheckout;